import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ViewController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the RegisteraddressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-registeraddress',
  templateUrl: 'registeraddress.html',
})
export class RegisteraddressPage {

    loginId: string;
    api_key: string;
    version: string;
    address: string;

    step: string = '1';

    texts: any = [];
    language: string;
    isSend : boolean = true;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        public alertCtrl: AlertController,
		public toastCtrl: ToastController,
        public viewCtrl: ViewController,
        private http: HttpService,
        public app: App
    ) {
        
    }

    ionViewWillEnter() {
        //// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
        this.api_key = localStorage.getItem("api_key");
        this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "registeraddress");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        
        this._get_texts();
    }

    _get_texts() {
        this.texts = JSON.parse(localStorage.getItem('lang_pack')).registeraddress;
    }

    _check() {
        if (!this.address || this.address.length == 0) {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_wallet,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}
        
        let url = "user/wallet/index/check";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            address: this.address
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                // let alert = this.alertCtrl.create({
                //     message: res.message,
                //     buttons: ['OK']
                // });
                // alert.present();
                this.step = '2';

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        
        },(err)=>{
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        });
    }

    _save() {
        let url = "user/wallet/index/save";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            address: this.address
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this._close();
                
            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        
        },(err)=>{
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        });
    }

    _prev() {
        if (this.step == "1") {
            this._close();
        } else {
            this.step = "1"
        }
    }

    
	_close() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/registeraddress/registeraddress.ts